var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProgressActivity = function SvgProgressActivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 8 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ACB5C2",
    d: "M4 8a3.9 3.9 0 0 1-1.55-.315 4.1 4.1 0 0 1-1.275-.86 4.1 4.1 0 0 1-.86-1.275A3.9 3.9 0 0 1 0 4q0-.83.315-1.555t.86-1.27T2.45.315A3.9 3.9 0 0 1 4 0q.17 0 .285.115A.39.39 0 0 1 4.4.4a.39.39 0 0 1-.115.285A.39.39 0 0 1 4 .8q-1.33 0-2.265.935A3.09 3.09 0 0 0 .8 4q0 1.33.935 2.265A3.09 3.09 0 0 0 4 7.2q1.33 0 2.265-.935A3.09 3.09 0 0 0 7.2 4q0-.17.115-.285A.39.39 0 0 1 7.6 3.6q.17 0 .285.115A.39.39 0 0 1 8 4a3.9 3.9 0 0 1-.315 1.55 4.06 4.06 0 0 1-2.13 2.135A3.9 3.9 0 0 1 4 8"
  })));
};
export { SvgProgressActivity as ReactComponent };
export default __webpack_public_path__ + "fonts/progress-activity-8545d6ebaf785abddb3c3fb0e73388ef.svg";